import { render, staticRenderFns } from "./bill-details.vue?vue&type=template&id=e2ef286a&scoped=true"
import script from "./bill-details.vue?vue&type=script&lang=js"
export * from "./bill-details.vue?vue&type=script&lang=js"
import style0 from "./bill-details.vue?vue&type=style&index=0&id=e2ef286a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ef286a",
  null
  
)

export default component.exports